// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"upload-spinner_ldsSpinner__8XSvD","lds-spinner":"upload-spinner_lds-spinner__7CYwB"};